import { assoc } from 'ramda';
import { VARIABLE_UPDATE, VARIABLE_CREATION } from 'utils/toastDispacher';
import { getBotspecInfo } from '../selectors';
import { saveBotSpec } from './chatbots';

const getTypeDefaultValue = (type) => {
  const types = {
    object: {},
    number: 0,
    array: [],
    string: '',
    integer: 0,
    boolean: false,
  };

  return types[type];
};

const saveNodeReferenceVariable = (
  botspec, reteNode, nodeId, properties,
) => {
  const nodes = botspec.rete_json.data;
  let node = nodes[nodeId];
  node = assoc('properties', properties, node);
  if (reteNode && reteNode.data) {
    // eslint-disable-next-line no-param-reassign
    reteNode.data.properties = properties;
    reteNode.update();
  }
  const data = { ...nodes, [nodeId]: { ...node } };
  return { ...botspec.rete_json, data };
};

const deleteNodeReferenceVariable = (
  botspec, reteNode, nodeId, properties, variableId, referenceId,
) => {
  const nodes = botspec.rete_json.data;
  let node = nodes[nodeId];
  const updatedVariables = { ...properties.resultVariables };
  delete updatedVariables[referenceId];
  const updatedProperties = {
    ...properties,
    resultVariables: updatedVariables,
  };

  node = assoc('properties', updatedProperties, node);

  if (reteNode && reteNode.data) {
    // eslint-disable-next-line no-param-reassign
    reteNode.data.properties = properties;
    reteNode.update();
  }
  const data = { ...nodes, [nodeId]: { ...node } };
  return { ...botspec.rete_json, data };
};

export const unMarkReferenceVariable = (
  nodeId, referenceId, variableId, properties,
) => (dispatch, getState, getContext) => {
  const { botspec } = getBotspecInfo(getState());
  const { editor } = getContext();
  const reteNode = editor && editor.nodes ? editor.nodes.find((node) => node.id === nodeId) : {};
  const updatedBotspec = deleteNodeReferenceVariable(
    botspec, reteNode, nodeId, properties, variableId, referenceId,
  );

  const sessionVars = botspec.spec_json.variables.session;
  const newBotspec = {
    ...botspec,
    rete_json: { ...updatedBotspec },
    spec_json: {
      ...botspec.spec_json,
      variables: {
        ...botspec.spec_json.variables,
        session: {
          ...sessionVars,
          [variableId]: { ...sessionVars[variableId], isMapped: false },
        },
      },
    },
  };

  dispatch(saveBotSpec(newBotspec, {
    actionId: VARIABLE_UPDATE,
    elementName: variableId,
  }));
};

export const deleteVariableReferences = (botspec, variableType, variableId) => {
  if (variableType === 'chatbot') {
    const { data } = botspec.rete_json;
    const updatedData = Object.keys(data).reduce((accum, key) => {
      const { properties } = data[key];
      if (properties.resultVariable && properties.resultVariable === variableId) {
        return {
          ...accum,
          [key]: {
            ...accum[key],
            properties: {
              ...accum[key].properties,
              resultVariable: '',
            },
          },
        };
      }
      return accum;
    }, { ...data });

    return { ...botspec, rete_json: { ...botspec.rete_json, data: updatedData } };
  }
  return botspec;
};

export const saveReferenceVariable = (
  nodeId, variableId, reference, properties,
) => (dispatch, getState, getContext) => {
  const { botspec } = getBotspecInfo(getState());
  const { editor } = getContext();
  const reteNode = editor && editor.nodes ? editor.nodes.find((node) => node.id === nodeId) : {};
  const varType = reference.type ?? 'string';

  const variableExists = !!botspec.spec_json.variables.session[variableId];
  const reteJson = saveNodeReferenceVariable(botspec, reteNode, nodeId, properties);
  const newBotspec = {
    ...botspec,
    rete_json: reteJson,
    spec_json: {
      ...botspec.spec_json,
      variables: {
        ...botspec.spec_json.variables,
        session: {
          ...botspec.spec_json.variables.session,
          [variableId]: { type: varType, value: getTypeDefaultValue(varType), isMapped: true },
        },
      },
    },
  };
  dispatch(saveBotSpec(newBotspec, {
    actionId: variableExists ? VARIABLE_UPDATE : VARIABLE_CREATION,
    elementName: variableId,
  }));
};

export const saveReferenceVariables = (
  nodeId, variables, properties,
) => (dispatch, getState, getContext) => {
  const { botspec } = getBotspecInfo(getState());
  const { editor } = getContext();
  const reteNode = editor && editor.nodes ? editor.nodes.find((node) => node.id === nodeId) : {};
  const reteJson = saveNodeReferenceVariable(botspec, reteNode, nodeId, properties);
  const newBotspec = {
    ...botspec,
    rete_json: reteJson,
    spec_json: {
      ...botspec.spec_json,
      variables: {
        ...botspec.spec_json.variables,
        session: {
          ...botspec.spec_json.variables.session,
          ...Object.keys(variables).reduce((accum, key) => ({
            ...accum,
            [variables[key].resultVariable]: {
              type: variables[key].referenceData.type,
              value: getTypeDefaultValue(variables[key].referenceData.type),
              isMapped: true,
            },
          }), {}),
        },
      },
    },
  };
  dispatch(saveBotSpec(newBotspec));
};
